import jwt_decode from 'jwt-decode';
import AppConfig from '../Constants/config';
import { userRole } from '../Constants/userRoles';
import _ from "lodash";
import moment from 'moment';
import { saveAs } from 'file-saver';
import { Component, Property } from 'immutable-ics'

function updateInLocalStorage(key, value) {
  window.localStorage.setItem(key, value);
}

function removeInLocalStorage(key) {
  window.localStorage.removeItem(key);
}

function getLocalStorageItem(key) {
  return window.localStorage.getItem(key);
}

function getUserFromLocalToken() {
  const accesstoken = getLocalStorageItem(AppConfig.ACCESS_TOKEN);
  if (accesstoken) {
    return jwt_decode(accesstoken);
  } else {
    return null;
  }
}

function clearLocalToken() {
  removeInLocalStorage(AppConfig.ACCESS_TOKEN);
  removeInLocalStorage(AppConfig.REFRESH_TOKEN);
}

function saveLocalToken(response) {
  console.log(response);
  if (response && response[AppConfig.ACCESS_TOKEN_PROP] && response[AppConfig.REFRESH_TOKEN_PROP]) {
    updateInLocalStorage(AppConfig.ACCESS_TOKEN, response[AppConfig.ACCESS_TOKEN_PROP]);
    updateInLocalStorage(AppConfig.REFRESH_TOKEN, response[AppConfig.REFRESH_TOKEN_PROP]);
  } else {
    throw new Error('Can not update local token with null value');
  }
}

function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
  decimalCount = Math.abs(decimalCount);
  decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
  const negativeSign = amount < 0 ? "-" : "";
  const i = parseInt(
    (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
  ).toString();
  const j = i.length > 3 ? i.length % 3 : 0;
  return (
    negativeSign +
    (j ? i.substr(0, j) + thousands : "") +
    i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${thousands}`) +
    (decimalCount
      ? decimal +
      Math.abs(amount - i)
        .toFixed(decimalCount)
        .slice(2)
      : "")
  );
}

function formatPhoneNumber(str) {
  //Filter only numbers from the input
  let cleaned = ('' + str).replace(/\D/g, '');
  if(cleaned.length > 10){
    cleaned = cleaned.substring(0,10);
  }

  //Check if the input is of correct length
  let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3]
  };

  return '';
};

function getPaginationArray(
  total,
  activeNumber,
  showLength = 1,
  marginLength = 0
) {
  // this method will retrun an array that represent what should be showed in the pagination
  // example: total : 10. show count = 2 active number = 5 output:[3,4,5,6,7]
  if (total > 0) {
    let left = activeNumber - showLength >= 1 ? activeNumber - showLength : 1;
    let right =
      activeNumber + showLength <= total ? activeNumber + showLength : total;
    if (right - activeNumber < showLength) {
      // can expend on left
      const remain = showLength - (right - activeNumber);
      left = left - remain >= 1 ? left - remain : 1;
    } else if (activeNumber - left < showLength) {
      // can expend on right
      const remain = showLength - (activeNumber - left);
      right = right + remain <= total ? right + remain : total;
    }
    // expend left if not reached 0
    let leftExtend = [];
    if (left > marginLength + 2) {
      leftExtend = _.range(1, Math.min(marginLength + 2, left));
      leftExtend.push("...");
    } else if (left >= marginLength + 1) {
      leftExtend = _.range(1, Math.min(marginLength + 2, left));
    }
    let rightExtend = [];
    if (right < total - marginLength - 1) {
      rightExtend.push("...");
      rightExtend = rightExtend.concat(
        _.range(Math.max(total - marginLength - 1, right), total + 1)
      );
    } else if (right >= total - marginLength - 1 && right < total) {
      rightExtend = _.range(
        Math.max(total - marginLength, right + 1),
        total + 1
      );
    }
    const result = leftExtend
      .concat(_.range(left, right + 1))
      .concat(rightExtend);
    return result;
  }
  return [];
}

function getFixedLengthText(text = '', textLength = 40,) {
  if (!(text && typeof text === 'string' && text.length)) {
    return '';
  } else {
    return text.length > textLength ? text.substring(0, textLength - 3) + '...' : text;
  }
}

function formatTime(inputDate, timeFormat = 'MM/DD/YYYY') {
  if (typeof inputDate === 'string' || typeof inputDate === 'object') {
    let momentObj = moment(inputDate);
    if (momentObj.isValid()) {
      return momentObj.format(timeFormat);
    } else {
      return '';
    }
  } else {
    return '';
  }
}

function getGUID() {
  let u = Date.now().toString(16) + Math.random().toString(16) + '0'.repeat(16);
  return [u.substr(0, 8), u.substr(8, 4), '4000-8' + u.substr(13, 3), u.substr(16, 12)].join('-');
}

function functionExist(testObject) {
  if (testObject && typeof testObject === 'function') {
    return true;
  } else {
    return false;
  }
}

function DownloadBlobExcelFileWithContentDisposition(response, fileName) {
  fileName = fileName !== undefined ? fileName : "result.xlsx";
  try {
    var disposition = response.headers["content-disposition"];
    if (disposition && disposition.indexOf("attachment") !== -1) {
      var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      var matches = filenameRegex.exec(disposition);
      if (matches != null && matches.length > 0 && matches[1])
        fileName = matches[1].replace(/['"]/g, "");
    }
  } catch (error) {
    console.error(error);
  }
  var blob = new Blob([response.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
  });
  const link = document.createElement("a");
  link.style.display = "none";
  link.href = window.URL.createObjectURL(blob);
  link.target = "_blank";
  link.setAttribute("download", fileName);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
}

function downloadICSFile(eventData) {
  /*
    eventData: {
      startTime: string;
      endTime: string;
      summary: string;
      description: string;
      location: string;
      fileName?: string;
    };
  
  */

    const calendar = new Component({
      name: 'VCALENDAR',
      properties: [
        new Property({ name: 'VERSION', value: 2 }),
        new Property({ name: 'PRODID', value: 'DC DDS Virtural Resource Room' })
      ],
      components: [
        new Component({
          name: 'VEVENT',
          properties: [
            new Property({
              name: 'SUMMARY',
              transform: false,
              value: `${eventData.summary || 'Summary not specified'}`
            }),
            new Property({
              name: 'DTSTART',
              parameters: { VALUE: 'DATE-TIME' },
              value: moment(eventData.startTime).toDate()
            }),
            new Property({
              name: 'DTEND',
              parameters: { VALUE: 'DATE-TIME' },
              value: moment(eventData.endTime).toDate()
            }),
            new Property({
              name: 'DESCRIPTION;ENCODING=QUOTED-PRINTABLE',
              transform: false,
              value: `${eventData.description}`
            }),
            new Property({
              name: 'LOCATION',
              value: `${eventData.location}`
            }),
          ]
        })
      ]
    })
    const fileText = calendar.toString();
    var blob = new Blob([fileText], {type: "text/plain;charset=utf-8"});
    saveAs(blob, eventData.fileName || `Employer_Spotlight_Presentation_${moment(eventData.startTime || '').format('MM_DD_YYYY')}.ics`);
    //console.log(calendar.toString());
}

function isValidPhone(testTarget) {
  let myReg = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
        return myReg.test(testTarget);
  return myReg.test(testTarget);
}



function formatCamelText(input){

  let result = input.replace( /([A-Z])/g, " $1" );
  return result;
}

function isCounselor(){
  const currUser = getUserFromLocalToken();
  return currUser?.Roles?.includes(userRole.Counselor) ? true : false;
}

function isEmploymentCoordinator(){
  const currUser = getUserFromLocalToken();
  return currUser?.Roles?.includes(userRole["Employment Coordinator"]) ? true : false;
}

function isCoordinatorSupervisor(){
  const currUser = getUserFromLocalToken();
  return currUser?.Roles?.includes(userRole["Coordinator Supervisor"]) ? true : false;
}

export const utils = {
  updateInLocalStorage,
  removeInLocalStorage,
  getLocalStorageItem,
  getUserFromLocalToken,
  clearLocalToken,
  saveLocalToken,
  formatMoney,
  formatTime,
  getPaginationArray,
  getFixedLengthText,
  getGUID,
  functionExist,
  formatPhoneNumber,
  DownloadBlobExcelFileWithContentDisposition,
  downloadICSFile,
  isValidPhone,
  formatCamelText,
  isCounselor,
  isEmploymentCoordinator,
  isCoordinatorSupervisor
};